export enum BookingType {
    BobbyCalfKill = 1,
    BobbyCalfKillMaster = 2,
    ContractKill = 3,
    FeedTransfer = 4,
    PaddockFeed = 5,
    PaddockKill = 6,
    ScheduleKill = 7,
    ServiceKill = 8,
};